<div class="form-header">
  <p>Verify your account settings below.</p>
  <p *ngIf="!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM')">
    Your role does not allow for saving settings changes on this screen.
  </p>
</div>
<form class="form-field-list" [formGroup]="form">
  <mat-form-field *ngIf="!useCompanyDropdown">
    <input matInput placeholder="Company Name" formControlName="accountNameText" [required]="!useCompanyDropdown">
  </mat-form-field>
  <mat-form-field *ngIf="useCompanyDropdown">
    <input type="text" matInput placeholder="Company Name" formControlName="accountNameDropdown" [matAutocomplete]="dropDown.auto" [required]="useCompanyDropdown" (blur)="forbiddenNames(form.controls.accountNameDropdown)">
    <cw-manage-company-dropdown #dropDown
      [partnerAccount]="parentAccount"
      [disableInUseCompanies]="true"
      [searchControl]="form.controls.accountNameDropdown"></cw-manage-company-dropdown>
    <mat-error *ngIf="form.controls.accountNameDropdown?.touched && !form.controls.accountNameDropdown?.value">Please select a value from the dropdown</mat-error>
    <mat-error *ngIf="form.controls.accountNameDropdown?.hasError('incorrect')">Please select a value from the dropdown</mat-error>
  </mat-form-field>
  <mat-form-field *ngIf="parentAccount?.automateIntegration?.isEnabled">
    <input type="text" matInput placeholder="Automate Client Name" formControlName="automateClientDropdown" [matAutocomplete]="automateClientsDropDown.auto">
    <cw-automate-client-dropdown #automateClientsDropDown [searchControl]="form.controls.automateClientDropdown" [partnerAccount]="parentAccount" [disableInUseClients]="true"></cw-automate-client-dropdown>
    <mat-error *ngIf="form.controls.automateClientDropdown?.touched && !form.controls.automateClientDropdown?.value">Please select a value from the dropdown</mat-error>
  </mat-form-field>
  <mat-form-field *ngIf="sessionService.isAccountType('SYSTEM') ;else exclude_plan_id">
    <mat-select placeholder="Plan" formControlName="plan" required>
      <mat-option *ngFor="let plan of availablePlans" [value]="plan.id">{{plan.name}} (id: {{plan.id}})</mat-option>
    </mat-select>
  </mat-form-field>
  <ng-template #exclude_plan_id>
    <mat-form-field >
      <mat-select placeholder="Plan" formControlName="plan" required>
        <mat-option *ngFor="let plan of availablePlans" [value]="plan.id">{{plan.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
  <mat-form-field *ngIf="account.id == undefined && planAssessments?.length > 0 && sessionService.isAccountType('SYSTEM') ;else exclude_assessment_id">
    <input type="text" matInput placeholder="Initial Assessment" formControlName="assessment" [matAutocomplete]="assessments.auto" required>
    <cw-assessments-dropdown #assessments [searchControl]="form.controls.assessment" 
      [planId]="form.controls.plan.value" [isInTrial]="isNewAccountInTrial" [excludeTypeList]="['CERTIFICATION']">
    </cw-assessments-dropdown>
  </mat-form-field>
  <ng-template #exclude_assessment_id>
    <mat-form-field *ngIf="account.id == undefined && planAssessments?.length > 0">
      <input type="text" matInput placeholder="Initial Assessment" formControlName="assessment" [matAutocomplete]="assessments.auto" required>
      <cw-assessments-dropdown #assessments [searchControl]="form.controls.assessment" 
        [planId]="form.controls.plan.value" [isInTrial]="isNewAccountInTrial" [excludeTypeList]="['CERTIFICATION']">
      </cw-assessments-dropdown>
    </mat-form-field>
  </ng-template>
  <ng-container *ngIf="account.type != 'SYSTEM'">
    <mat-form-field>
      <mat-select placeholder="Company Industry" formControlName="Industry" required>
        <mat-option *ngFor="let industry of PROFILE_CONSTANTS.INDUSTRIES" [value]="industry">{{industry}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-select placeholder="Company Location" formControlName="Location" required>
        <mat-option *ngFor="let location of PROFILE_CONSTANTS.LOCATIONS" [value]="location">{{location}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-select placeholder="Number of Employees" formControlName="Employees" required>
        <mat-option *ngFor="let employee of PROFILE_CONSTANTS.COMPANY_SIZE" [value]="employee">{{employee}}</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="sessionService.isAccountType('SYSTEM') && account.id != undefined">
      <mat-form-field>
        <input type="text" matInput placeholder="Central Service Partner Id" formControlName="centralServicePartnerId"
        [matAutocomplete]="csPartnerDropDown.auto"  (blur)="forbiddenFreeForm(form.controls.centralServicePartnerId)">
        <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN) && account.parentId == undefined">
          <mat-icon color="primary" svgIcon="cw:action_edit" actionColor="primary" class="editicon" (click)="enablePartnerDropdown()"></mat-icon>
        </ng-container>        
        <cw-cs-partner-dropdown #csPartnerDropDown [searchControl]="form.controls.centralServicePartnerId" [disableInUseCompanies]="false" [partnerAccount]="account" [key]="'centralServicePartnerId'">
        </cw-cs-partner-dropdown>
        <mat-error *ngIf="form.controls.centralServicePartnerId?.hasError('incorrect')">Please select a value from the dropdown</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input type="text" matInput placeholder="Central Service Instance Id" formControlName="instanceId" [matAutocomplete]="csinstanceIdDropdown.auto"  (blur)="forbiddenFreeForm(form.controls.instanceId)">
        <ng-container *ngIf="sessionService.hasRole(RoleType.ADMIN) && account.parentId == undefined">
          <mat-icon color="primary" svgIcon="cw:action_edit" actionColor="primary" class="editicon" (click)="enableInstanceDropdown()"></mat-icon>
        </ng-container>        
        <cw-cs-partner-dropdown #csinstanceIdDropdown [searchControl]="form.controls.instanceId" (eventHandler)="handleEvent($event)" [disableInUseCompanies]="true" [partnerAccount]="parentAccount" [key]="'centralServiceInstanceId'">          
        </cw-cs-partner-dropdown>
        <mat-error *ngIf="form.controls.instanceId?.hasError('incorrect')">Please select a value from the dropdown</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Instance status" formControlName="instanceStatus">
          <mat-option *ngFor="let istatus of PROFILE_CONSTANTS.INSTANCE_STATUSES" [value]="istatus">{{istatus}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput [matDatepicker]="trialendpicker" placeholder="Trial period end" formControlName="trialPeriodEndDate">
        <mat-datepicker-toggle matSuffix [for]="trialendpicker"></mat-datepicker-toggle>
        <mat-datepicker #trialendpicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Payment status" formControlName="paymentStatus">
          <mat-option *ngFor="let pstatus of PROFILE_CONSTANTS.PAYMENT_STATUSES" [value]="pstatus">{{pstatus}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput [matDatepicker]="billingDatePicker" placeholder="Billing start date" formControlName="billingStartDate">
        <mat-datepicker #billingDatePicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
  </ng-container>
</form>